import React from "react";
import { useHistory } from "react-router-dom";
import { StatusMarker } from "../../../../components/statusMarker";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import { BriefType } from "../../../../constants/types";
import { getBriefPageUrl } from "../../../navigation/types/pages.functions";
import { StyledTableCell, StyledTableRow, useStyles } from "./brief-list-table.styles";
import { TableRowType } from "../../types/brief-list-table/table-row-type.enum";
import { TableSectionType } from "../../types/brief-list-table/table-section-type.enum";
import { BriefListTableProps } from "./brief-list-table.props";
import { getLabelForTemplateType } from "../../../../types/templates/template-type.functions";
import { AvatarList } from "../../../../components/layout/listing-table/listing-table-render-components";

export const BriefListTable = ({ dataList, briefType }: BriefListTableProps) => {
  const classes = useStyles();
  const firstRow = dataList[0];
  const history = useHistory();

  const dataListWithoutHeader = () => {
    if (firstRow?.type === TableRowType.HEADER_CELL) {
      return dataList.slice(1);
    } else {
      return dataList;
    }
  };

  const firstHeaderTitle = () => {
    switch (briefType) {
      case BriefType.CAMPAIGN_BRIEF:
        return "Campaign Name";
      case BriefType.EXECUTION_BRIEF:
        return "Name";
      case BriefType.WORK_ORDER:
        return "Brief Work Order Name";
    }
  };

  const wrongDataCells = (index = 0) => (
    <TableRow key={index}>
      <StyledTableCell align="left" colSpan={7}>
        <Typography variant={"h5"} style={{ marginTop: "50px", marginBottom: "20px" }}>
          Wrong Data - please check the element of dataList
        </Typography>
      </StyledTableCell>
    </TableRow>
  );

  const templateHeaderCells = () => {
    switch (briefType) {
      case BriefType.CAMPAIGN_BRIEF:
      case BriefType.EXECUTION_BRIEF:
        return <StyledTableCell scope="header">Template</StyledTableCell>;
      default:
        return null;
    }
  };

  const templateCells = (briefData: any) => {
    switch (briefType) {
      case BriefType.CAMPAIGN_BRIEF:
      case BriefType.EXECUTION_BRIEF:
        return <StyledTableCell>{getLabelForTemplateType(briefData.resourcetype)}</StyledTableCell>;
      default:
        return null;
    }
  };

  const dateHeaderCells = () => {
    switch (briefType) {
      case BriefType.CAMPAIGN_BRIEF:
        return (
          <>
            <StyledTableCell scope="header">Start Date</StyledTableCell>
            <StyledTableCell scope="header">End Date</StyledTableCell>
          </>
        );
      case BriefType.EXECUTION_BRIEF:
        return <StyledTableCell scope="header">Created Date</StyledTableCell>;
      case BriefType.WORK_ORDER:
        return (
          <>
            <StyledTableCell scope="header">Assignees</StyledTableCell>
            <StyledTableCell scope="header">Multi Channel Brief</StyledTableCell>
            <StyledTableCell scope="header">Creative Due Date</StyledTableCell>
          </>
        );
    }
  };

  const dateCells = (briefData: any) => {
    switch (briefType) {
      case BriefType.CAMPAIGN_BRIEF:
        return (
          <>
            <StyledTableCell>{briefData.startAt}</StyledTableCell>
            <StyledTableCell>{briefData.endAt}</StyledTableCell>
          </>
        );
      case BriefType.EXECUTION_BRIEF:
        return <StyledTableCell>{briefData.date}</StyledTableCell>;
      case BriefType.WORK_ORDER:
        return (
          <>
            <StyledTableCell>
              <AvatarList users={briefData.contentCreatorDetails} noUsersMessage="Unassigned" />
            </StyledTableCell>
            <StyledTableCell>{briefData.executionBriefName}</StyledTableCell>
            <StyledTableCell>{briefData.dueDate}</StyledTableCell>
          </>
        );
    }
  };

  return (
    <TableContainer
      style={{ marginTop: firstRow?.section === TableSectionType.TODAY ? "-10px" : "0" }}
    >
      <Table className={classes.table} size="small" aria-label="table">
        <TableHead>
          <TableRow>
            <StyledTableCell align="left" style={{ minWidth: "150px" }}>
              {firstRow?.section ? (
                <Typography
                  variant={"h2"}
                  style={{
                    fontSize: "1.5rem",
                    marginBottom: "20px",
                    opacity:
                      firstRow.section === TableSectionType.TODAY &&
                      dataList[1].type !== TableRowType.VACANT_CELL
                        ? "0"
                        : "1",
                  }}
                >
                  {firstRow.name}
                </Typography>
              ) : (
                firstHeaderTitle()
              )}
            </StyledTableCell>
            <StyledTableCell scope="header" style={{ paddingLeft: "34px" }}>
              Status
            </StyledTableCell>
            <StyledTableCell scope="header">Owner</StyledTableCell>
            {templateHeaderCells()}
            {dateHeaderCells()}
            <StyledTableCell scope="header">Approvers</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {dataListWithoutHeader().map((row: any, index: number) => {
            if (row.type) {
              if (row.section) {
                if (row.type === TableRowType.VACANT_CELL) {
                  return (
                    <TableRow key={index}>
                      <StyledTableCell align="center" colSpan={7} scope="vacant">
                        <Typography variant={"h6"} style={{ margin: "20px", fontWeight: "normal" }}>
                          {row.name}
                        </Typography>
                      </StyledTableCell>
                    </TableRow>
                  );
                } else {
                  return (
                    <TableRow key={index}>
                      <StyledTableCell align="left" colSpan={7}>
                        <Typography
                          variant={"h5"}
                          style={{ marginTop: "50px", marginBottom: "20px" }}
                        >
                          {row.name}
                        </Typography>
                      </StyledTableCell>
                    </TableRow>
                  );
                }
              } else {
                // Debug purpose - when something wrong in data
                return wrongDataCells(index);
              }
            } else if (row.id) {
              return (
                <StyledTableRow
                  tabIndex={0}
                  onClick={() => {
                    history.push(`${getBriefPageUrl(briefType)}/${row.id}`);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      history.push(`${getBriefPageUrl(briefType)}/${row.id}`);
                    }
                  }}
                >
                  <StyledTableCell component="th" scope="name">
                    <b>{row.name.length > 92 ? row.name.substr(0, 91) + "..." : row.name}</b>
                  </StyledTableCell>
                  <StyledTableCell>
                    <StatusMarker status={row.status} />
                  </StyledTableCell>
                  <StyledTableCell>{row.ownerName}</StyledTableCell>
                  {templateCells(row)}
                  {dateCells(row)}
                  <StyledTableCell>
                    <AvatarList users={row.reviewers} />
                  </StyledTableCell>
                </StyledTableRow>
              );
            } else {
              // Debug purpose - when something wrong in data
              return wrongDataCells(index);
            }
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
